const SkeletonCard = () => (
  <div className="overflow-hidden h-screen flex flex-col bg-gray-800/20 animate-pulse">
    {/* Top Image Area */}
    <div className="h-[60%] bg-gray-700/30" />
  </div>
);

export default function ProjectsSkeleton() {
  return (
    <div className="bg-[#120428] py-20 px-6 md:px-16 mt-10 text-white min-h-screen">
      <div className="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-1 gap-6">
        {[...Array(1)].map((_, i) => (
          <SkeletonCard key={i} />
        ))}
      </div>
    </div>
  );
}